import { EventMode } from '@/types/menu-setting';

export const homeEventModeIcons: Record<EventMode, string> = {
	M0: '/images/home/nav/icon_sports.webp',
	M1: '/images/home/nav/icon_olympic.webp',
	M2: '/images/home/nav/icon_world-cup.webp',
	M3: '/images/home/nav/icon_euro-cup.webp',
	M4: '/images/home/nav/icon_olympic-winter.webp',
	M5: '/images/home/nav/icon_copa-america.webp',
	M6: '/images/home/nav/icon_world-cup-w.webp',
	M7: '/images/home/nav/icon_uefa-euro-w.webp',
	M8: '/images/home/nav/icon_asian-games.webp',
	M9: '/images/home/nav/icon_afc-asian-cup.webp',
	M10: '/images/home/nav/icon_afc-asian-cup-w.webp',
	M11: '/images/home/nav/icon_fiba-world-cup.webp',
	M12: '/images/home/nav/icon_fiba-world-cup-w.webp',
	M13: '/images/home/nav/icon_cup-default.webp',
	M14: '/images/home/nav/icon_sea-games.webp',
	M15: '/images/home/nav/icon_fiba-ameri-cup.webp',
	M16: '/images/home/nav/icon_fiba-euro-w.webp',
	M17: '/images/home/nav/icon_fiba-ameri-cup-w.webp',
	M18: '/images/home/nav/icon_fiba-afro-w.webp',
	M19: '/images/home/nav/icon_fiba-euro.webp',
	M20: '/images/home/nav/icon_fiba-afro.webp',
	M21: '/images/home/nav/icon_commonwealth-games.webp',
	M22: '/images/home/nav/icon_uefa-nations-league.webp',
	M23: '/images/home/nav/icon_aff-championship.webp',
	M24: '/images/home/nav/icon_aff-championship-w.webp',
	M25: '/images/home/nav/icon_fiba-asia-cup.webp',
	M26: '/images/home/nav/icon_fiba-asia-cup-w.webp',
	M27: '/images/home/nav/icon_virtual-euro.webp',
	M28: '/images/home/nav/icon_virtual-copa.webp',
	M29: '/images/home/nav/icon_virtual-epl.webp',
	M30: '/images/home/nav/icon_cup-default.webp',
	M31: '/images/home/nav/icon_cup-default.webp',
	M32: '/images/home/nav/icon_cup-default.webp',
	M33: '/images/home/nav/icon_cup-default.webp',
	M34: '/images/home/nav/icon_club-world-cup.webp',
	M35: '/images/home/nav/icon_australian-open.webp',
	M36: '/images/home/nav/icon_roland-garros.webp',
	M37: '/images/home/nav/icon_us-open.webp',
	M38: '/images/home/nav/icon_wimbledon.webp',
	M39: '/images/home/nav/icon_fivb-nations-league.webp',
	M40: '/images/home/nav/icon_fivb-world-championship.webp',
	M41: '/images/home/nav/icon_badminton-asia-championship.webp',
	M42: '/images/home/nav/icon_bwf-world-championships.webp',
	M43: '/images/home/nav/icon_badminton-thomas-uber-cup.webp',
	M44: '/images/home/nav/icon_bwf-world-tour-finals.webp',
	M45: '/images/home/nav/icon_indian-premier-league.webp',
	M46: '/images/home/nav/icon_icc-t20-world-cup.webp',
	M47: '/images/home/nav/icon_icc-world-cup.webp',
	M48: '/images/home/nav/icon_icc-champions-trophy.webp',
	M49: '/images/home/nav/icon_nba.webp',
	M50: '/images/home/nav/icon_saba-virtual-fifa-world-cup.webp',
	M51: '/images/home/nav/icon_fun88-virtual-fifa-world-cup.webp',
	M52: '/images/home/nav/icon_m88-virtual-fifa-world-cup.webp',
};

export const DEFAULT_HOME_EVENT_MODE_ICON = '/images/home/nav/icon_cup-default.webp';